// extracted by mini-css-extract-plugin
export default {"container":"ValidationNameCell_container__PRzVA"};